import { render, staticRenderFns } from "./postpone.vue?vue&type=template&id=4c347214&scoped=true&"
import script from "./postpone.vue?vue&type=script&lang=js&"
export * from "./postpone.vue?vue&type=script&lang=js&"
import style0 from "./postpone.vue?vue&type=style&index=0&id=4c347214&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c347214",
  null
  
)

export default component.exports